import { BrowserRouter, Routes, Route } from "react-router-dom";
import {
  Box,
  Container,
  Typography,
  CssBaseline,
  Tab,
  Tabs,
  Grid,
  CircularProgress,
} from "@mui/material";
import { ThemeProvider } from "@mui/system";

import React, { useEffect, useReducer, useState } from "react";

import { useAppProvider } from "./AppContext";
import Cat20List from "./components/Cat20List";
import Cat721List from "./components/Cat721List";
import NavBar from "./components/NavBar";
import { theme } from "./theme";
import {
  CollectionItem,
  getCollectionItems,
  getTokenItems,
  NFTItem,
  TokenItem,
} from "./api";
import SwapDialog from "./components/SwapDialog";
import { Notification } from "./components/Notification";
import History from "./components/History";
import SwapNftDialog from "./components/SwapNftDialog";
import FAQCollapse from "./components/FAQCollapse";

function Home() {
  const { connected, connectedAccount, network } = useAppProvider();

  const [_tabIndex, setTabIndex] = useState(0);

  const [_tokenItems, setTokenItem] = useState<Array<TokenItem>>([]);

  const [_collectionItems, setCollectionItems] = useState<
    Array<CollectionItem>
  >([]);

  const [_loadingCat20, setLoadingCat20] = React.useState(true);
  const [_loadingCat721, setLoadingCat721] = React.useState(true);

  const [_notificationSeverity, setNotificationSeverity] = useState<
    "info" | "error" | "warning" | "success"
  >("info");
  const [_notificationMsg, setNotificationMsg] = useState<string | undefined>();

  const [_selectedTokenItem, setSelectedTokenItem] = useState<TokenItem | null>(
    null
  );

  const [_selectedNft, setSelectedNft] = useState<{
    collectionItem: CollectionItem;
    nftItem: NFTItem;
  } | null>(null);

  const handleClose = () => {
    setSelectedTokenItem(null);
    setSelectedNft(null);
    forceUpdate();
    console.log("forceUpdate");
  };

  const [_x, forceUpdate] = useReducer((x) => x + 1, 0);

  const tabOnChange = (e: React.SyntheticEvent, tabIndex: number) => {
    setTabIndex(tabIndex);
  };

  useEffect(() => {
    if (connected() && connectedAccount) {
      setLoadingCat20(true);
      getTokenItems(network, connectedAccount!.payment.address)
        .then((items) => {
          setTokenItem(items);
          setLoadingCat20(false);
        })
        .catch((e) => {
          console.error("get token list failed:", e);
          setLoadingCat20(false);
        });
    }
  }, [connected, connectedAccount, network, _x]);

  useEffect(() => {
    if (connected() && connectedAccount) {
      setLoadingCat721(true);
      getCollectionItems(network, connectedAccount!.payment.address)
        .then((items) => {
          setCollectionItems(items);
          setLoadingCat721(false);
        })
        .catch((e) => {
          console.error("get collection list failed:", e);
          setLoadingCat721(false);
        });
    }
  }, [connected, connectedAccount, network, _x]);

  const handleSwapToken = (tokenItem: TokenItem) => {
    console.log("handleSwap", tokenItem);

    if (tokenItem.confirmed === "0") {
      setNotificationSeverity("error");
      setNotificationMsg("No available v1 token!");
      return;
    }
    setSelectedTokenItem(tokenItem);
  };

  const handleSwapNft = (collectionItem: CollectionItem, nftItem: NFTItem) => {
    console.log("handleSwapNft", nftItem);
    setSelectedNft({
      collectionItem,
      nftItem,
    });
  };

  return (
    <>
      <NavBar />
      <Box sx={{ width: "100%", mt: 5 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          CAT Protocol Upgrade
        </Typography>
      </Box>
      <Box sx={{ width: "100%", mt: 5 }}>
        <Grid container justifyContent="center">
          <Tabs value={_tabIndex} onChange={tabOnChange}>
            <Tab label="CAT20" disabled={!connected()} />
            <Tab label="CAT721" disabled={!connected()} />
            <Tab label="HISTORY" disabled={!connected()} />
          </Tabs>
        </Grid>
        {connected() && _tabIndex === 0 && (
          <Box
            sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}
          >
            {_loadingCat20 && _x === 0 ? (
              <CircularProgress sx={{ mt: 5 }} />
            ) : (
              <Cat20List items={_tokenItems} swap={handleSwapToken} />
            )}
          </Box>
        )}
        {connected() && _tabIndex === 1 && (
          <Box
            sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}
          >
            {_loadingCat721 && _x === 0 ? (
              <CircularProgress sx={{ mt: 5 }} />
            ) : (
              <Cat721List items={_collectionItems} swapNft={handleSwapNft} />
            )}
          </Box>
        )}

        {connected() && _tabIndex === 2 && (
          <Box
            sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}
          >
            <History />
          </Box>
        )}

        {_selectedTokenItem !== null ? (
          <SwapDialog
            tokenItem={_selectedTokenItem}
            handleClose={handleClose}
          ></SwapDialog>
        ) : (
          <></>
        )}

        {_selectedNft !== null ? (
          <SwapNftDialog
            nftItem={_selectedNft.nftItem}
            collectionItem={_selectedNft.collectionItem}
            handleClose={handleClose}
          ></SwapNftDialog>
        ) : (
          <></>
        )}

        <Notification
          message={_notificationMsg}
          setMessage={setNotificationMsg}
          severity={_notificationSeverity}
        />
      </Box>

      {connected() ? (
        ""
      ) : (
        <Container
          maxWidth="sm"
          sx={{
            height: "20vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <br />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mt: 3,
            }}
          >
            <Typography align="center">Do not have a Wallet?</Typography>
            <br />

            <Box sx={{ width: 200 }}>
              <Grid container spacing={2}>
                {/* <Grid item xs={6}>
                  <Typography align="center">
                    👉{" "}
                    <a
                      href="https://chromewebstore.google.com/detail/%E6%AC%A7%E6%98%93-web3-%E9%92%B1%E5%8C%85/mcohilncbfahbmgdjkbpemcciiolgcge"
                      style={{ color: "#FE9C2F" }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      OKX
                    </a>
                  </Typography>
                </Grid> */}
                <Grid item xs={12}>
                  <Typography align="center">
                    👉{" "}
                    <a
                      href="https://chromewebstore.google.com/detail/unisat-wallet/ppbibelpcjmhbdihakflkdcoccbgbkpo"
                      style={{ color: "#FE9C2F" }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Unisat
                    </a>
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Container>
      )}

      <Container
        maxWidth="sm"
        sx={{
          height: "20vh",
          paddingTop: 15,
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Typography variant="h3" component="h3" gutterBottom align="center">
          FAQ
        </Typography>
        <Grid container justifyContent="center">
          <FAQCollapse />
        </Grid>
      </Container>

    </>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
